import { withStyles } from '@material-ui/core';

import PlaceholderItem from './PlaceholderItem';
import { styles } from './PlaceholderItem.styles';

const PlaceholderItemContainer = withStyles(styles)(PlaceholderItem);

export default PlaceholderItemContainer;
